/**
 * @voltxampere/ui — NPN BJT (NPN) · IEC encapsulation
 *
 * Encapsulating circle (r=10 at 22,13) with the heavy base bar at
 * x=16. NPN convention: arrow on the emitter lead points OUT of the
 * body. Collector terminal sits at top-right (32, 4); emitter at
 * bottom-right (32, 22).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_HEAVY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT, } from "./constants.js";
export const npn = {
    id: "npn",
    nameTr: "NPN",
    nameEn: "NPN BJT",
    shortcut: "Q",
    category: "active",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 10, y: 13, label: "B", polarity: "in" },
        { x: 32, y: 4, label: "C", polarity: "in" },
        { x: 32, y: 22, label: "E", polarity: "out" },
    ],
    defaultLabel: "Q",
    renderSVG: () => [
        `<circle cx="22" cy="13" r="10" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="16" y1="7" x2="16" y2="19" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_HEAVY)}"/>`,
        `<line x1="10" y1="13" x2="16" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="16" y1="10" x2="28" y2="4" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="28" y1="4" x2="32" y2="4" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="16" y1="16" x2="28" y2="22" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="28" y1="22" x2="32" y2="22" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<polygon points="22,19 26,21 22,23" fill="${STROKE_IVORY}"/>`,
    ].join(""),
};
//# sourceMappingURL=npn.js.map